import { useModalGlobalState } from 'contexts/casa-ideas'
import dynamic from 'next/dynamic'
import { FC } from 'react'
import s from './Modal.module.scss'

const PylotModal = dynamic(() => import('@corratech/pylot-ui/src/Modal'))

const Modal: FC = () => {
    const { state, modalClose } = useModalGlobalState()
    const { modalOpened, modalContent } = state

    return (
        <PylotModal
            allowScrolling
            className={s['modal']}
            onClose={modalClose}
            open={modalOpened}
            focusFirst={false}
        >
            {modalContent}
        </PylotModal>
    )
}

export default Modal
